import { getLocalStorage } from "@utils/localStorage";

const APP_SHOP_URL = window.globalData.APP_SHOP_URL;
export const DEFAULT_API_PATH_TEST = 'api/jtails/v1';
export const DEFAULT_API_PATH_PROD = 'api/jtails/v1';
export const DEFAULT_API_PATH = 'api/jtails/v1';

const getBaseURL = () => {
  const isSetApiDev = getLocalStorage('set.isApiDev');
  const isDevelopment = process.env.NODE_ENV === 'development';

  if(isDevelopment) {
    return DEFAULT_API_PATH_TEST
  }
  if(!isSetApiDev && !isDevelopment) {
    return DEFAULT_API_PATH_PROD
  }

  return DEFAULT_API_PATH
};

const baseURL = APP_SHOP_URL + getBaseURL();

export default {
  name: 'api-wordpress', // api 名稱
  baseURL: baseURL, // baseURL,
  endLoadingDelay: 0, // 延遲loading結束時間
  errorHandle: true, // 執行錯誤處理（顯示message, 登出判斷, reject）
  showMessage: true, // 顯示message
  logoutRedirect: true, // 登出轉址判斷
  isThrottle: false, // 防止連續執行兩次(開發中)
}
